/**
 * @package
 */
export const sentryConfig: {
  /**
   * 개발 모드 여부.
   */
  dev: boolean;

  /**
   * 강제 capture 전까지 최대 에러 개수.
   */
  maxErrorCount: number;

  /**
   * 로그 카테고리.
   */
  defaultCategory: string;

  platformName: string;
} = {
  dev: false,
  maxErrorCount: 10,
  defaultCategory: 'App',
  platformName: 'unknown',
};

/**
 * Sentry 설정을 변경합니다.
 */
export const setSentryConfig = (config: Partial<typeof sentryConfig>) => {
  Object.assign(sentryConfig, config);
};
